// Normalização canônica de telefone (BR). Mirror da função PG normalize_phone() e do
// _shared/phone-normalize.ts da edge function. Resultado: dígitos, 12 (fixo) ou 13 (móvel),
// sempre com prefixo "55".

export function normalizePhone(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const clean = raw.replace(/\D/g, '');
  if (!clean) return null;

  let normalized: string;
  if (clean.length >= 10 && clean.length <= 11) {
    normalized = `55${clean}`;
  } else if (clean.length >= 12 && clean.length <= 13 && clean.startsWith('55')) {
    normalized = clean;
  } else {
    normalized = `55${clean}`;
  }

  if (normalized.length === 12) {
    const firstDigitAfterDDD = normalized[4];
    if (firstDigitAfterDDD >= '6') {
      normalized = normalized.substring(0, 4) + '9' + normalized.substring(4);
    }
  }

  return normalized;
}

/**
 * Variantes de um telefone canônico, para BUSCA — nunca para gravação.
 *
 * Espelho de `getPhoneVariants` em `supabase/functions/_shared/phone-normalize.ts`.
 * Existe porque a base tem linhas anteriores ao backfill de `20260410200000_backfill_normalize_phone`:
 * um móvel gravado sem o 9º dígito continua com 12 dígitos no banco, enquanto
 * `normalizePhone` devolve 13. Sem a variante, uma ligação entrante desse número não
 * encontra o lead.
 */
export function getPhoneVariants(normalized: string | null | undefined): string[] {
  if (!normalized || !normalized.startsWith('55')) {
    return normalized ? [normalized] : [];
  }

  const variants: string[] = [normalized];
  const ddd = normalized.substring(2, 4);

  if (normalized.length === 13 && normalized[4] === '9') {
    // Móvel com o 9 → também procura a forma legada sem o 9.
    variants.push(`55${ddd}${normalized.substring(5)}`);
  } else if (normalized.length === 12 && normalized[4] >= '6') {
    // Móvel de 12 dígitos não deveria existir depois da normalização, mas cobre entrada crua.
    variants.push(`55${ddd}9${normalized.substring(4)}`);
  }

  return variants;
}

/**
 * Normalização para o formato aceito pelo discador Sonax (DDD + número, sem 55, sem 0 na frente).
 * Retorna 10 dígitos (fixo) ou 11 dígitos (móvel) ou null se inválido.
 */
export function normalizePhoneForSonax(raw: string | null | undefined): string | null {
  const canonical = normalizePhone(raw);
  if (!canonical) return null;
  if (!canonical.startsWith('55')) return null;
  const sonax = canonical.slice(2);
  if (sonax.length !== 10 && sonax.length !== 11) return null;
  return sonax;
}
